import React from "react";
import PropTypes from "prop-types";
import { RiAddLine, RiSubtractLine } from "react-icons/ri";

const QuantityControl = ({ quantity, onDecrement, onIncrement }) => {
  return (
    <div
      className="h-[40px] min-w-[150px] border border-[#cfcfcf] grid grid-cols-3 items-stretch px-4"
      style={{
        border: "1px solid #BAB9B9",
      }}
    >
      <button
        type="button"
        aria-label="Decrease quantity"
        onClick={onDecrement}
        className="flex items-center justify-center text-black/80 hover:text-black transition-colors"
      >
        <RiSubtractLine className="h-5 w-5" />
      </button>
      <div className="flex items-center justify-center font-mono text-[14px] text-black">
        {quantity}
      </div>
      <button
        type="button"
        aria-label="Increase quantity"
        onClick={onIncrement}
        className="flex items-center justify-center text-black/80 hover:text-black transition-colors"
      >
        <RiAddLine className="h-5 w-5" />
      </button>
    </div>
  );
};

QuantityControl.propTypes = {
  quantity: PropTypes.number.isRequired,
  onDecrement: PropTypes.func.isRequired,
  onIncrement: PropTypes.func.isRequired,
};

export default QuantityControl;
